import React from 'react';
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';
import { useDispatch, useSelector } from 'react-redux';
import { ToggleButton } from '@mui/material';
import { uiSelectors } from 'src/selectors';
import { toggleSettingsSidebarStatus } from './../../../redux/slices/ui';

const SettingsSidebarButton = () => {
  const isSidebarOpen = useSelector(uiSelectors.isSettingsSidebarOpen());
  const dispatch = useDispatch();

  return (
    <ToggleButton
      value="check"
      selected={isSidebarOpen}
      onChange={() => {
        dispatch(toggleSettingsSidebarStatus());
      }}
    >
      <SettingsEthernetIcon />
    </ToggleButton>
  );
};

export default SettingsSidebarButton;
